var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJavascript(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 80 80",
    width: "80px",
    height: "80px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface152759054"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(32.549021%,92.54902%,80.784315%)",
      fillOpacity: 1
    },
    d: "M 10 70 L 10 10 L 70 10 L 70 70 Z M 10 70 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(3.921569%,9.803922%,18.431373%)",
      fillOpacity: 1
    },
    d: "M 49.230469 54.910156 C 50.382812 56.785156 51.636719 58.578125 54.292969 58.578125 C 56.523438 58.578125 57.691406 57.472656 57.691406 55.9375 C 57.691406 54.101562 56.480469 53.453125 54.027344 52.382812 L 52.683594 51.808594 C 48.800781 50.164062 46.21875 48.101562 46.21875 43.742188 C 46.21875 39.726562 49.296875 36.667969 54.101562 36.667969 C 57.523438 36.667969 59.980469 37.851562 61.753906 40.957031 L 57.5625 43.636719 C 56.640625 41.988281 55.644531 41.339844 54.101562 41.339844 C 52.523438 41.339844 51.523438 42.335938 51.523438 43.636719 C 51.523438 45.242188 52.523438 45.890625 54.832031 46.886719 L 56.179688 47.460938 C 60.753906 49.410156 63.332031 51.398438 63.332031 55.871094 C 63.332031 60.691406 59.527344 63.332031 54.417969 63.332031 C 49.417969 63.332031 46.578125 60.824219 45 57.71875 Z M 29.921875 55.046875 C 30.761719 56.558594 32.046875 57.71875 33.886719 57.71875 C 35.652344 57.71875 36.667969 57.023438 36.667969 54.316406 L 36.667969 36.667969 L 42.222656 36.667969 L 42.222656 55.167969 C 42.222656 60.78125 38.964844 63.332031 34.214844 63.332031 C 29.917969 63.332031 26.816406 60.421875 25.554688 57.71875 Z M 29.921875 55.046875 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript);
export default __webpack_public_path__ + "static/media/javascript.4a2afb96033d1663803c6cecf9f671ab.svg";
export { ForwardRef as ReactComponent };